<!-- <div *ngIf="hasHeader" class="d-none d-md-block d-lg-block d-xl-block">
  <div class="cx-item-list-header row">
    <div class="cx-item-list-desc col-md-5 col-lg-5 col-xl-6">
      {{ 'cartItems.description' | cxTranslate }}
    </div>
    <div class="cx-item-list-price col-md-3 col-lg-2 col-xl-2">
      {{ 'cartItems.itemPrice' | cxTranslate }}
    </div>
    <div class="cx-item-list-qty col-md-2 col-lg-3 col-xl-2">
      {{ 'cartItems.quantity' | cxTranslate }}
    </div>

    <ng-container *ngIf="options.isSaveForLater; else totalHeader">
      <div class="cx-item-list-total col-md-2 col-lg-2 col-xl-2">
        {{ 'saveForLaterItems.stock' | cxTranslate }}
      </div>
    </ng-container>
  </div>
</div> -->

<div class="row cart-action-container">
  <div class="action-left">
    <div class="vs-checkbox check-all-holder pl-2">
      <input
        id="check-all"
        type="checkbox"
        value="true"
        name="check-all"
        [(ngModel)]="checkAll"
        (click)="checkAllEntries($event)"
        [ngClass]="cart?.quoteCartType ? 'disabled' : ''"
      />
      <label for="check-all" class="cart-item-check"></label>
    </div>
    <span
      [ngClass]="
        (checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)
          ? ''
          : 'hide-btn'
      "
    >
      <a
        class="action-links"
        (click)="addToQuoteCart()"
        [ngClass]="cart?.quoteCartType ? 'disabled' : ''"
      >
        <i class="material-icons receipt mr-1"> receipt </i>
        <span class="mr-3">{{ "savedCart.getAQuote" | cxTranslate }}</span>
      </a>
    </span>
    
    <span>
      <a
        class="action-links"
        (click)="checkAvailability()"
        [ngClass]="cart?.quoteCartType ? 'disabled' : ''"
      >
      <i class="material-icons-outlined task mr-1"> task_outline </i>
        <span class="mr-3">{{ "savedCart.checkAvailabilityLabel" | cxTranslate }}</span>
      </a>
    </span>
    <span>
      <a
        class="action-links"
        (click)="openDeleteDialog(false)"
      >
        <i class="material-icons delete mr-1"> delete </i>
        <span >{{ "savedCart.delete" | cxTranslate }}</span>
      </a>
    </span>
  </div>
  <div class="action-right">
    <!-- [ngClass]="!cart.partialShipping ? 'disabled': ''" -->
    <a
      class="action-links mr-4"
      (click)="openDeliveryGroupsDialog()"
      [class.disabled]="!isShipmentPartial"
    >
      <span class="material-icons mr-1"> local_shipping </span>
      <span>{{ "savedCart.createDeliveryGroups" | cxTranslate }}</span>
    </a>
    <a class="action-links mr-4" (click)="openDeleteDialog(true)">
      <span class="material-icons-outlined mr-1"> delete_outline </span>
      <span>{{ "savedCart.clearCart" | cxTranslate }}</span>
    </a>
    <a
      class="action-links mr-4"
      (click)="downloadCart()"
      [ngClass]="cart?.quoteCartType ? 'disabled' : ''"
    >
      <i class="material-icons-outlined mr-1"> save_alt </i>
      <span>{{ "savedCart.downloadXLS" | cxTranslate }}</span>
    </a>
    <!-- <a class="action-links mr-4" [ngClass]="cart?.quoteCartType ? 'disabled': ''">
      <i class='material-icons mr-2'>
        share
      </i>
      <span>share cart</span>
    </a> -->
    <a
      class="action-links"
      (click)="openSaveCartModal()"
      [ngClass]="cart?.quoteCartType ? 'disabled' : ''"
    >
      <i class="material-icons mr-2"> save </i>
      <span>{{ "savedCart.saveCartLowerCase" | cxTranslate }}</span>
    </a>
  </div>
</div>

<mat-accordion multi>
  <mat-expansion-panel [expanded]="true" disabled>
    <mat-expansion-panel-header class="accordtion-header bdr-btm" role="none">
      <div class="row w-100 accordion-header-row">
        <div class="col-md-2 pl-0">
          <div class="float-left cart-header-cell-1">
            <span>#</span>
            <span class="prodcutImg">{{ "savedCart.productCamelCase" | cxTranslate }}</span>
          </div>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-2 pl-0">{{ "savedCart.quantityCamelCase" | cxTranslate }}</div>
        <div class="col-md-2 pl-0">{{ "savedCart.priceCamelCase" | cxTranslate }}</div>
        <div class="col-md-2 pl-0">{{ "savedCart.additionalDetails" | cxTranslate }}</div>
        <div class="col-md-1 right expandAll p-0">
          <a class="panel-head" (click)="toggleButton()">
            <span *ngIf="!showToggle">{{ "savedCart.expandall" | cxTranslate }}<i  class="material-icons">
              keyboard_arrow_down
            </i></span>
            <span *ngIf="showToggle">{{ "savedCart.collapseall" | cxTranslate }}<i  class="material-icons">
              keyboard_arrow_up
            </i></span>
          </a>
        </div>
      </div>
    </mat-expansion-panel-header>

    <!-- <div *ngIf = "cartData$ | async as catData else loading">
      <div *ngFor="let product of catData.entries">
            <vs-quote-cart-product
            [product]="product"
            [customerRequestedDate]="dateAll"
            [productOpen]="showToggle"
            (refreshList)="refreshList($event)"
          ></vs-quote-cart-product>

      </div>    
    </div>  -->

    <div class="cx-item-list-row" *ngFor="let item of items; let i = index">
      <div
        class="cx-item-list-items"
        *ngIf="getControl(item) | async as control"
        [class.is-changed]="control.get('quantity').dirty"
      >
        <vs-cart-item
          [item]="item"
          [quantityControl]="control.get('quantity')"
          [readonly]="readonly"
          [promotionLocation]="promotionLocation"
          [options]="options"
          [entryNum]="i"
          [totalEntries]="items.length"
          [productOpen]="showToggle"
          [userType]="userType"
          [cart]="cart"
          [checkAll]="checkAll"
          (selectedEntry)="onEntryCheck($event)"
          (selectedMultipleEntry)="onMultipleEntryCheck($event)"
          #cartEntry
        >
        </vs-cart-item>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #totalHeader>
  <div class="cx-item-list-total col-md-2 col-lg-2 col-xl-2">
    {{ "savedCart.total" | cxTranslate }}
  </div>
</ng-template>
